/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function BoltIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M26.11 4c1.19 0 2.067 1.188 1.754 2.313L24.48 18h5.39c1.19 0 2.13 1 2.13 2.188q0 1.031-.752 1.687l-16.23 13.75q-.47.375-1.128.375c-1.19 0-2.068-1.125-1.754-2.25L15.52 22h-5.452A2.084 2.084 0 0 1 8 19.938c0-.625.25-1.188.69-1.625L24.981 4.438c.313-.25.689-.438 1.128-.438m-2.256 5.313L12.512 19h5.013c.438 0 .877.25 1.19.625.251.375.376.875.251 1.313l-2.82 9.812L27.614 21h-5.076c-.501 0-.94-.187-1.253-.562-.251-.375-.376-.875-.251-1.313z"/>}
        </IconWrapper>);
}
